/**
 * @function init
 * @description Initializes the wishlist functions by fetching the list and adding event listeners.
 * @param {Swat} swat
 * @returns {void}
 */
const init = async (swat) => {
  await fetchList(swat);
  if (!window.swymSelectedListId) {
    createList(swat);
  }
  addSwymEventListener(swat);
};

/* Fetches the wishlist data. */
const fetchList = async (swat) => {
  return new Promise((resolve, reject) => {
    const onSuccess = (lists) => {
      window.swymWishLists = lists;
      window.swymSelectedListId = lists && lists[0] && lists[0].lid;
      resolve(lists);
      updateButtonState();
    };

    const onError = (error) => {
      console.log('Error while fetching all Lists', error);
      reject(error);
    };

    if (!window.swymWishLists) {
      swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError,
      });
    } else {
      resolve(window.swymWishLists);
    }
  });
};

/* Create a new wishlist if not already exist. */

const createList = (swat) => {
  let listConfig = { lname: 'My Wishlist' };

  let onSuccess = function ({ lid }) {
    console.log('Successfully created a new List', lid);
    window.swymSelectedListId = lid;
  };

  let onError = function (error) {
    console.log('Error while creating a List', error);
  };

  swat.createList(listConfig, onSuccess, onError);
};

/* Refreshes the wishlist by fetching the list again in the global scope. */

const refreshList = async (swat) => {
  console.log('> refreshList');
  window.swymWishLists = null;
  await fetchList(swat);
};

/* Adds product to wishlist action. */

const addToWishlist = (swat, product) => {
  let onSuccess = async function (addedListItem) {
    console.log('Product has been added to wishlist!', addedListItem);
  };

  let onError = function (error) {
    console.error('Error Adding Product to Wishlist', error);
    // swat.ui.showErrorNotification({ message: 'Error Adding Product to Wishlist' });
  };

  let lid = window.swymSelectedListId;

  swat.addToList(lid, product, onSuccess, onError);
};

/* Remove product from wishlist action. */

const removeFromWishlist = (swat, product) => {
  let onSuccess = async function (deletedProduct) {
    console.log('Product has been removed from wishlist!', deletedProduct);
  };

  let onError = function (error) {
    // swat.ui.showErrorNotification({ message: 'Error removing Product from Wishlist' });
  };

  let lid = window.swymSelectedListId;

  swat.deleteFromList(lid, product, onSuccess, onError);
};

/**
 * @function updateButtonState
 * @description Updates the state of wishlist buttons based on whether items are wishlisted.
 * @returns {void}
 */
const updateButtonState = () => {
  const swymWishlistButtons = document.querySelectorAll(
    'swymcs-wishlist-button button[type="button"]'
  );

  if (!swymWishlistButtons.length) {
    return;
  }

  swymWishlistButtons.forEach((swymWishlistButton) => {
    // const elements = swymWishlistButton.elements;
    const { epi, empi } = swymWishlistButton.dataset;
    let isWishlisted = false;
    for (const list of window.swymWishLists) {
      for (const item of list.listcontents) {
        if (item.empi == empi && item.epi == epi) {
          isWishlisted = true;
        }
      }
    }
    updateButtonWishlistState(swymWishlistButton, isWishlisted);
  });
};

/**
 * @function updateButtonWishlistState
 * @description Updates the display state of a wishlist button based on whether the item is wishlisted.
 * @param {HTMLButtonElement} buttonElement
 * @param {Boolean} isWishlisted
 * @returns {void}
 */
const updateButtonWishlistState = (buttonElement, isWishlisted) => {
  let settings = JSON.parse(buttonElement?.dataset?.settings || '{}');
  if (isWishlisted) {
    buttonElement.classList.add('swym-added-custom');
    if (settings?.disable_added_to_wishlist) {
      buttonElement?.setAttribute('disabled', true);
    }
  } else {
    buttonElement?.classList?.remove('swym-added-custom');
    buttonElement?.classList?.remove('disabled');
    buttonElement?.removeAttribute('disabled');
  }
};

/* Render multiple wishlist popup when multiple wishlist enabled */

const renderPopup = async (product) => {
  let popup = document.querySelector('swym-wishlist-popup');
  let { epi, empi, du } = product;
  window.currentActiveProduct = await fetchProductsData(du);
  window.currentActiveVariant = currentActiveProduct.variants.find((variant) => variant.id == epi);
  window.currentActiveVariantId = epi;
  window.currentActiveProduct.url = du;
  setTimeout(popup._show.bind(popup), 100);
};

/* Fetches product data from shopify to get updated data. */

const fetchProductsData = async (url) => {
  const productData = await fetch(`${url}.js`);
  if (productData.status === 404 || !productData.ok) return null;
  const jsonData = await productData.json();
  return jsonData;
};

/* Adds event listeners for wishlist actions. */

const addSwymEventListener = (swat) => {
  swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, (event) => {
    let image = event.detail.d.iu;
    let title = event.detail.d.dt;
    showCustomNotification(swat, image, title, 'remove', 1);
    refreshList(swat);
  });

  swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, (event) => {
    let image = event.detail.d.iu;
    let title = event.detail.d.dt;
    showCustomNotification(swat, image, title, 'add', 1);
    refreshList(swat);
  });

  swat.evtLayer.addEventListener(swat.JSEvents.variantChanged, (data) => {
    const currentVariant = data.detail.d.variant.id;
    const currentProductId = data.detail.d.product.id;
    const swymCustomWishlistButton = document.querySelector(
      `.swymcs-wishlist-button-${currentProductId}`
    );
    if (swymCustomWishlistButton) {
      swymCustomWishlistButton.setAttribute('data-epi', currentVariant);
    }
    setTimeout(updateButtonState, 200);
  });
};

const showCustomNotification = (swat, image, title, action, listCount) => {
  let successMessage = `
      <style>
          .swym-notification-success-inner .swym-image{ display: none !important }
          #swym-custom-notification-content { display: flex; gap: 10px; align-items: center; cursor: pointer }
          #swym-custom-notification-content #swym-custom-image-container { min-height: 50px; min-width: 50px; max-height: 50px; max-width: 50px }
          #swym-custom-notification-content #swym-custom-image-container #swym-custom-image { width: 100%; height: 100%; object-fit: cover; border-radius: 50% }
          #swym-custom-notification-content #swym-custom-title-container { font-weight: 500; font-size: 14px }
      </style>
      <div id="swym-custom-notification-content" onclick="_swat.ui.open()">
          <div id="swym-custom-image-container">
              <img id="swym-custom-image" src="${image}" alt="wishlisted product image"/>
          </div>
          <div id="swym-custom-title-conatainer"><strong>${title}</strong> has been ${action == 'remove' ? 'removed from' : 'added to'} <strong> ${listCount == 1 ? 'list!' : 'lists!'}</strong></div>
      </div>
    `;
  swat.ui.showSuccessNotification({ message: successMessage });
};

/* Creating a global object to assign functions */

const swymcsWishlistFunctions = {
  init,
  fetchList,
  refreshList,
  updateButtonState,
  updateButtonWishlistState,
  addToWishlist,
  removeFromWishlist,
  addSwymEventListener,
  fetchProductsData,
  renderPopup,
  showCustomNotification,
};

/* Push the init functions into SwymCallbacks  */

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymcsWishlistFunctions.init);

/* Expose swymcsWishlistFunctions to the global scope */

window.swymcsWishlistFunctions = swymcsWishlistFunctions;

/**
 * @class SwymWishlistButton
 * @extends HTMLElement
 * @description Custom element for the Swym wishlist button
 */
class SwymWishlistButton extends HTMLElement {
  constructor() {
    super();
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(this.handleWishlistButton.bind(this));
  }

  async handleWishlistButton(swat) {
    this.wishlistButton = this.querySelector('button.swymcs-wishlist-button');
    this.elements = {
      wishlistButton: this.querySelector('button.swymcs-wishlist-button'),
      unfilledState: this.querySelector('[data-swym-unfilled]'),
      filledState: this.querySelector('[data-swym-filled]'),
    };

    this.updateAriaState(false);

    this.elements.wishlistButton.addEventListener('click', async () => {
      let { epi, empi, du } = this.wishlistButton.dataset;
      let product = { epi, empi, du };

      try {
        if (swat.isCollectionsEnabled()) {
          await swymcsWishlistFunctions.renderPopup(product);
          return;
        }
        const isAdded = this.wishlistButton.classList.contains('swym-added-custom');
        if (!isAdded) {
          await swymcsWishlistFunctions.addToWishlist(swat, product);
          this.updateAriaState(true);
          return;
        }

        await swymcsWishlistFunctions.removeFromWishlist(swat, product);
        this.updateAriaState(false);
      } catch (error) {
        console.error('Error handling wishlist action:', error);
      }
    });
  }

  updateAriaState(isWishlisted) {
    const button = this.wishlistButton;
    button.setAttribute('aria-pressed', isWishlisted ? 'true' : 'false');
    button.classList.toggle('swym-added-custom', isWishlisted);
    button.setAttribute(
      'aria-label',
      `${isWishlisted ? 'Remove' : 'Add'} ${isWishlisted ? 'from' : 'to'} wishlist`
    );
  }
}
customElements.define('swymcs-wishlist-button', SwymWishlistButton);
